// removed by extract-text-webpack-plugin
module.exports = {"button":"styles__button___3Ej2e","label":"styles__label___WZeFP","button-content":"styles__button-content___FVIrH","icon":"styles__icon___2Wnd6","disabled-icon":"styles__disabled-icon___3_KIn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/icon/styles.css
// module id = 664
// module chunks = 0